module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/hairmake_sns_03-23f0061966113e8dd5ea9fb901f87f20.jpg";